import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { UserPlus } from 'lucide-react';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    email: '',
    senha: ''
  });
  const [loginLoading, setLoginLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    
    const success = await login(loginData.email, loginData.senha);
    if (!success) {
      setLoginLoading(false);
    }
  };

  const handleCadastrarPrestador = () => {
    navigate('/cadastro-prestador');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-stone-100 dark:from-stone-950 dark:to-stone-900 flex items-center justify-center p-4 transition-colors duration-300">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mb-4">
            <img 
              src="/logo.png" 
              alt="Logo Identidade Gente" 
              className="h-16 w-auto mx-auto object-contain"
              style={{ maxWidth: '200px' }}
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Identidade Gente</h1>
          <p className="text-gray-600 dark:text-gray-300 mt-2">Sistema de Gestão de Diárias</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Entrar no Sistema</CardTitle>
            <CardDescription>
              Entre com suas credenciais para acessar o sistema
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  value={loginData.email}
                  onChange={(e) => setLoginData({...loginData, email: e.target.value})}
                  placeholder="seu@email.com"
                  required
                />
              </div>
              
              <div>
                <Label htmlFor="senha">Senha</Label>
                <Input
                  id="senha"
                  type="password"
                  value={loginData.senha}
                  onChange={(e) => setLoginData({...loginData, senha: e.target.value})}
                  placeholder="••••••••"
                  required
                />
                <div className="text-right mt-1">
                  <button
                    type="button"
                    onClick={() => navigate('/esqueci-senha')}
                    className="text-sm text-primary hover:underline font-medium"
                    data-testid="esqueci-senha-link"
                  >
                    Esqueci minha senha
                  </button>
                </div>
              </div>
              
              <Button 
                type="submit" 
                className="w-full" 
                disabled={loginLoading}
              >
                {loginLoading ? 'Entrando...' : 'Entrar'}
              </Button>
            </form>
            
            {/* Separador */}
            <div className="relative my-6">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t border-gray-300 dark:border-border" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-white dark:bg-card px-2 text-gray-500 dark:text-gray-400">ou</span>
              </div>
            </div>
            
            {/* Botão para cadastro de prestador */}
            <Button 
              type="button"
              variant="outline" 
              className="w-full"
              onClick={handleCadastrarPrestador}
            >
              <UserPlus className="mr-2 h-4 w-4" />
              Sou prestador e quero me cadastrar
            </Button>
            
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 text-center">
              O cadastro é exclusivo para prestadores de serviço. 
              Contas de acesso ao sistema são criadas pela administração.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
